import { styled, Theme, Colors } from '@unfold/theme';
import { Typography } from '@unfold/typography';

export const DropzoneWrapper = styled.div`
  margin-top: 20px;
`;

export const Divider = styled.div`
  height: 1.4px;
  width: calc(100% + 48px);
  background-color: #eeeeee;
  margin: 25px -24px;
`;

export const StyledLabel = styled(Typography)`
  font-size: 16px;
  color: ${({ theme }): string =>
    theme.name === Theme.LIGHT ? Colors.G300 : Colors.G600};
`;

export const ErrorMessage = styled.span`
  display: block;
`;